import React, { Component } from "react";
import {
  mediaType,
  mediaStatus
} from "WEBSOCKET/constants";

import { USER_ROLES } from "UTILS/Constants";
import { isIE, isMobileSafari } from "react-device-detect";

import { getMessage } from "CONFIG/i18n";
import { audioVideoAction } from "CONFIG/ActionFactory";
import { wsocket } from "WEBSOCKET/wsocket";

import audio_off from "ASSETS/Images/video_menu/ic_audio_off_small_transparent.svg";
import audio_on from "ASSETS/Images/video_menu/ic_audio_on_small_transparent.svg";
import audio_disable from "ASSETS/Images/video_menu/ic_audio_disable_small_transparent.svg";
import video_on from "ASSETS/Images/video_menu/ic_video_on_small_transparent.svg";
import video_off from "ASSETS/Images/video_menu/ic_video_off_small_transparent.svg";
import video_disable from "ASSETS/Images/video_menu/ic_video_disable_small_transparent.svg";
import ic_config from "ASSETS/Images/video_menu/ic_config.svg";
import ic_config_disable from "ASSETS/Images/video_menu/ic_config_disable.svg";

export default class MobileControlBar extends Component {
  constructor(props) {
    super(props);
  }
  isAudioType = () => {
    return this.props.participant.mediaType === mediaType.AUDIO_VIDEO || this.props.participant.mediaType === mediaType.AUDIO
  }
  isVideoType = () => {
    return this.props.participant.mediaType === mediaType.AUDIO_VIDEO || this.props.participant.mediaType === mediaType.VIDEO
  }
  showVideoSettingModal = () => {
    let showModal = true;
    if(this.props.userRole === USER_ROLES.USER && this.props.webRtcPermissionRequest !== mediaType.AUDIO_VIDEO) showModal = false;
    return showModal
  }

  render(){
    return(
      <div
        className={this.props.parentClassname}>
        <div className={this.props.iconsDivClassname}>
          <div className={`${this.props.className}${!this.isAudioType() ? " cursorDisabled" : ""}`}
            onClick={(e) => {
              // restrict click of audio/video box
              e.stopPropagation()
              if(!this.isAudioType()) return
              if(this.props.participant.uniqueId === this.props.uniqueId) {
                if(!isIE) {
                  let sender = wsocket.audioAndVideoRtcPeer[this.props.uniqueId]["AUDIO"].peerConnection.getSenders().find(function (s) {
                    return s.track.kind == 'audio';
                  });
                  if(sender && sender.track) {
                    // if audioStatus is muted enable audio for unmuting
                    sender.track.enabled = this.props.participant.audioStatus === mediaStatus.MUTED
                    || this.props.participant.audioStatus === mediaStatus.MUTED_BY_AGENT ? true : false;
                    console.log('AUDIO sender.track.enabled: ', sender.track.enabled);
                  }
                }
                audioVideoAction.setParticipantMediaStatus({
                  uniqueId: this.props.uniqueId,
                  audioStatus: this.props.participant.audioStatus === mediaStatus.MUTED
                  || this.props.participant.audioStatus === mediaStatus.MUTED_BY_AGENT
                    ? mediaStatus.UNMUTED
                    : mediaStatus.MUTED
                });
                audioVideoAction.toggleMedia(
                  this.props.sessionKey,
                  mediaType.AUDIO,
                  (this.props.participant.audioStatus === mediaStatus.MUTED
                    || this.props.participant.audioStatus === mediaStatus.MUTED_BY_AGENT) 
                    ? mediaStatus.UNMUTED 
                    : mediaStatus.MUTED,
                  this.props.participant.uniqueId
                );
              } 
            }}>
            <img
              className={this.props.participant.uniqueId === this.props.uniqueId 
                ? "audioIcon cursorPointer"
                : "audioIcon cursorDisabled"
              }
              src={ !this.isAudioType() 
                ? audio_disable
                : (this.props.participant.audioStatus === mediaStatus.MUTED
                || this.props.participant.audioStatus === mediaStatus.MUTED_BY_AGENT)
                  ? audio_off
                  : audio_on
              }
              title={
                this.props.participant.uniqueId === this.props.uniqueId
                  ? (this.props.participant.audioStatus === mediaStatus.MUTED
                    || this.props.participant.audioStatus === mediaStatus.MUTED_BY_AGENT)
                    ? getMessage("UNMUTE_AUDIO")
                    : getMessage("MUTE_AUDIO")
                  : ""
              }
            />
            {getMessage("MICROPHONE")}
          </div>
          {
            !this.props.hideButton && (
              <div className={`${this.props.className}${!this.isVideoType() ? " cursorDisabled" : ""}`}
                onClick={(e) => {
                  // restrict click of audio/video box
                  e.stopPropagation()
                  if(!this.isVideoType()) return
                  if (this.props.participant.uniqueId === this.props.uniqueId) {
                    if(!isIE) {
                      let sender = wsocket.audioAndVideoRtcPeer[this.props.uniqueId]["VIDEO"].peerConnection.getSenders().find(function (s) {
                        return s.track.kind == 'video';
                      });
                      if(sender && sender.track) {
                      // if videoStatus is muted enable video for unmuting
                        sender.track.enabled = this.props.participant.videoStatus === mediaStatus.MUTED
                          || this.props.participant.videoStatus === mediaStatus.MUTED_BY_AGENT ? true : false;
                        console.log('VIDEO sender.track.enabled: ', sender.track.enabled);
                      }
                    }
                    audioVideoAction.setParticipantMediaStatus({
                      uniqueId: this.props.uniqueId,
                      videoStatus: this.props.participant.videoStatus === mediaStatus.MUTED
                      || this.props.participant.videoStatus === mediaStatus.MUTED_BY_AGENT
                        ? mediaStatus.UNMUTED
                        : mediaStatus.MUTED
                    });
                    audioVideoAction.toggleMedia(
                      this.props.sessionKey,
                      mediaType.AUDIO_VIDEO,
                      (this.props.participant.videoStatus === mediaStatus.MUTED
                        || this.props.participant.videoStatus === mediaStatus.MUTED_BY_AGENT) 
                        ? mediaStatus.UNMUTED 
                        : mediaStatus.MUTED,
                      this.props.participant.uniqueId
                    )
                  } 
                }}
              >
                <img
                  className=
                    {this.props.participant.uniqueId === this.props.uniqueId 
                      ? "videoIcon cursorPointer"
                      : "videoIcon cursorDisabled"
                    }
                  src={
                    !this.isVideoType()
                      ? video_disable
                      : (this.props.participant.videoStatus === mediaStatus.MUTED
                          || this.props.participant.videoStatus === mediaStatus.MUTED_BY_AGENT)
                        ? video_off
                        : video_on
                  }
                  title={this.props.participant.uniqueId === this.props.uniqueId
                    ? (this.props.participant.videoStatus === mediaStatus.MUTED
                    || this.props.participant.videoStatus === mediaStatus.MUTED_BY_AGENT)
                      ? getMessage("UNMUTE_VIDEO")
                      : getMessage("MUTE_VIDEO")
                    : ""
                  }
                />
                {getMessage("VIDEO")}
              </div>
            )
          }
          <div
            className={`${this.props.className}${!this.showVideoSettingModal() ? " cursorDisabled" : ""}`}
            onClick={() => {
              // if (isMobileSafari) {
              //   this.stopTracks(this.currentStream);
              // }
              if(!this.showVideoSettingModal()) return
              if(this.props.participant.mediaType === mediaType.NONE){
                this.props.headerAction.setShowPreviewModal(true);
              } else {
                console.log("audioVideo")
                audioVideoAction.setAudioSettingModal(true);
              }
            }}
          >
            <img
              src={!this.showVideoSettingModal() ? ic_config_disable : ic_config}
              className="videoIcon cursorPointer"
              title={getMessage("AUDIO_SETTING")}
            />
            {getMessage("AUDIO_SETTING")}
          </div>
          <div className="clearBox"></div>
        </div>
      </div>
    );
  }
}
